import React, {Component} from "react";
import axios from "axios";
import store from '../store';
import Reviews from './Reviews';

const api = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/buyer/`
})
const itemApi = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/seller/GigsApi/`
})

class BuyerOrders extends Component {
    constructor(props) {
        super(props);
        this.state = {
            BuyerOrders:[],
            currentItem:null,
            id:null,
        }
    }
    componentDidMount(){
        this.getNewOrders();
      }
    getNewOrders = async () => {
        let data = await api.get(`BuyerOrdersAPI/${store.getState().auth.user.id}/`).then(({data})=>data);
        this.setState({BuyerOrders:data})
    }
    
    render() {
        return(
            <>
            <div className='container mt-5 pt-5 mx-5 px-5'>
            <h1>{this.props.status.toUpperCase()} </h1>
                
                {this.state.BuyerOrders.map(a =>
                (a.status === this.props.status || this.props.status === 'all') ?
                <div className='ps-5 ms-5 mt-4 w3-light-gray row' >
                     <h5 className='pt-2'>Order # 00{a.id}<br/>
                     <span style={{color:'gray',fontSize:'12px'}}>Placed on {a.created_at.slice(0, 10)} {a.created_at.slice(11, 19)}</span><hr style={{padding: '0px',margin: '0px'}}/>
                     </h5>
                     
                     {a.order_items.map(order_item => 
                        <React.Fragment>
                            <div className='col  col-lg-6 row'>
                                <div className='col col-lg-4' >
                                    <img src={order_item.item.images} style={{height:'130px', width:'130px'}} alt="..." />
                                </div>
                                <div className='col ' style={{fontSize:'12px'}} >
                                    {order_item.item.title}
                                </div>
                            </div>
                            <div className='col' style={{textAlign:'center'}}>
                                <span style={{color:'gray'}}>Qty:</span>{order_item.quantity}
                            </div>

                            <div className='col'>
                                {a.status === 'new order'? 'Processing' : a.status}
                            </div>
                            {this.props.status === 'shipped' ?
                            <div className='col'>
                                <button className='btn btn-primary' data-bs-toggle="modal" data-bs-target="#Review" onClick={()=>{this.setState({currentItem:order_item.item.id, id:a.id})}}>Review</button>
                            </div>
                            : null}
                            <br />
                            <hr style={{padding: '0px',margin: '0px', marginTop: 10, marginBottom: 10}}/>
                        </React.Fragment>
                    )}
                     
                 </div>
                : null
                )}      
            </div>
            <br/><br/><br/>
            <div className="modal fade" id="Review" tabIndex="-1" aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">Review & Ratings</h5>
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={()=>this.getNewOrders()}></button>
                </div>
                <div className="modal-body">
                    <Reviews buyer={store.getState().auth.user.id} item={this.state.currentItem} id={this.state.id}/>
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={()=>this.getNewOrders()} >Close</button>
                </div>
                </div>
            </div>
            </div>
            </>
    )
    }
} 
export default BuyerOrders;